module.exports = __webpack_public_path__ + "img/icon-2.d64b4f38.png";